window.addEventListener('DOMContentLoaded', () => {
    footerNewsletterWrapper();

    function footerNewsletterWrapper (){
        const footerNewsletterFormSubmit = document.querySelector(".footer-newsletter-form-submit");

        if(!footerNewsletterFormSubmit){
            return 0;
        }

        let newsletterErrorMessage = document.querySelector(".newsletter-error-message");
        let footerNewsletterCheckbox = document.getElementById("footerNewsletterCheckbox");

        footerNewsletterFormSubmit.addEventListener('click', (eventClick) => {
            if(footerNewsletterCheckbox.checked == false){
                newsletterErrorMessage.style.display = "block";
                eventClick.preventDefault();
            }
        });

        footerNewsletterCheckbox.addEventListener('click', (clicked) => {
            if(footerNewsletterCheckbox.checked == true){
                newsletterErrorMessage.style.display = "none";
            }
        });
    }
});